import { htmlE } from "/WebInterface/new-ui/assets/js/utils/te.js";

export const shareDetailsLayoutTemplate = htmlE`<div class="h-full is-flex is-flex-direction-column">
<div class="is-flex is-justify-content-space-between is-align-items-center">

    <div>
        <button data-tooltip="prev" class="manage-share-details-hover-btn manage-share-details-prev-btn" aria-label="forward-btn">
            <i class="icon-chevron-left"></i>
        </button>
        <button data-tooltip="next" class="manage-share-details-hover-btn manage-share-details-next-btn" aria-label="backward-btn">
            <i class="icon-chevron-right"></i>
        </button>
    </div>

    <div id="shareDetailsActions" class="is-flex gap-5">
    </div>

</div>

<div id="share-details-data" class="is-flex-grow-1 is-auto mt-3">
    <div class="is-flex text-sm share-details-column-wrapper">
        <div class="share-details-data-left is-flex is-flex-direction-column p-3">
        </div>
        <div class="share-details-data-right is-flex is-flex-direction-column p-3">
        </div>
    </div>
</div>
</div>`;

export const shareDetailsDataGridTemplate = htmlE`<div class="share-details-data-grid py-2">
    <div>
        <span data-i18n-key="${"i18n_key"}" class="has-text-weight-semibold is-pulled-right">${"title"}</span>
    </div>
    <div>
        <span class="share-details-data-grid-value">${"value"}</span>
    </div>
    <div class="text-primaryMain is-cursor-pointer search-button">
        <span class="icon is-small">
            <i class="icon-search mr-1"></i>
        </span>
    </div>
</div>`;

export const editButtonTemplate = htmlE`
        <button
            tabindex="0"
            type="button"
            id="manageShareDetailsEdit"
            class="primary-button is-bg-none p-0"
            aria-label="manage-shares-details-edit-btn"
        >
            <i class="icon-edit mr-2 text-accentMain"></i>
            <span data-i18n-key="edit">${"editText"}</span>
        </button>`;

export const deleteButtonTemplate = htmlE`
        <button
            tabindex="0"
            type="button"
            id="manageShareDetailsDelete"
            class="primary-button is-bg-none p-0"
            aria-label="manage-shares-details-delete-btn"
        >
            <i class="icon-trash mr-2 text-error"></i>
            <span data-i18n-key="Delete">${"deleteText"}</span>
        </button>`;
